import { Injectable } from '@angular/core';
import { loaderStyle } from './loaderStyleEnum';
import { loaderSource } from './loaderSourceEnum';




@Injectable()
export class LoaderService {

  loaderStatus: boolean;
  loaderStyle: number;
  loaderMessages: any;
  loaderHide = false;
  public globalErrorOccured = false;
  public sessionExpired = false;
  data: any;
  constructor() {
    this.data = {
      "addLead": {
        "messages": [
          "Adding Lead. . ."
        ]
      },
      "generateQuotation": {
        "messages": [
          "Generating Quote. . ."
        ]
      },
      "submitPolicy": {
        "messages": [
          "Submitting Policy. . ."
        ]
      },
      "movingToEApp": {
        "messages": ["Creating New proposal for select product. . ."]
      },
      "generateQuotationPDF": {
        "messages": [
          "Generating Quotation PDF. . ."
        ]
      },
      "saveQuotation": {
        "messages": [
          "Saving Quotation. . ."
        ]
      },
      "addActivity": {
        "messages": [
          "Adding Activity. . ."
        ]
      },
      "addNote": {
        "messages": [
          "Adding Activity. . ."
        ]
      },
      "premiumRefresh": {
        "messages": [
          "Recalculating Premium for changed Insured Value. . ."
        ]
      }


    }
  }

  public setLoader(loaderStyle, loaderSource) {
    this.loaderStyle = loaderStyle;
    this.loaderMessages = this.getMessagesForSource(loaderSource);
    // this.loaderMessages = "Loading . . ."
    console.log(this.loaderMessages);
    this.loaderStatus = true;
  }

  public startLoaderWithMessage(startmsg) {
    this.loaderStyle = 1;
    this.loaderMessages = startmsg;
    this.loaderStatus = true;

  }

  public showGlobalError(startmsg) {
    this.loaderStyle = 1;
    this.loaderMessages = startmsg;
    this.loaderStatus = true;
    this.loaderHide = true;
    this.globalErrorOccured = true
    console.log("Global Error Handler")



  }

  public showSessionExpired(startmsg) {
    this.loaderStyle = 1;
    this.loaderMessages = startmsg;
    this.loaderStatus = true;
    this.loaderHide = true;
    this.sessionExpired = true



  }

  public hideLoader() {
    this.loaderStyle = null;
    this.loaderMessages = null;
    this.loaderStatus = false;
  }

  public stopLoader() {

    var ms = 1 * 1000;
    setTimeout(() => {
      this.hideLoader();
    }, ms);
  }

  public instantStopLoader() {
    this.hideLoader();
  }

  public stopLoaderWithMessage(stopMsg) {
    this.loaderStyle = 1;
    this.loaderMessages = stopMsg;
    var ms = 2 * 1000;
    setTimeout(() => {
      this.hideLoader();
    }, ms);
  }

  public getMessagesForSource(src) {

    console.log(src);
    if (src === 'default' && this.data['default'])
      return this.data['default'].messages;
    else if (src === 'addLead' && this.data['addLead'])
      return this.data['addLead'].messages;
    else if (src === 'generateQuotation' && this.data['generateQuotation'])
      return this.data['generateQuotation'].messages;
    else if (src === 'submitPolicy' && this.data['submitPolicy'])
      return this.data['submitPolicy'].messages;
    else if (src === 'generateQuotationPDF' && this.data['generateQuotationPDF'])
      return this.data['generateQuotationPDF'].messages;
    else if (src === 'saveQuotation' && this.data['saveQuotation'])
      return this.data['saveQuotation'].messages;
    else if (src === 'addActivity' && this.data['addActivity'])
      return this.data['addActivity'].messages;
    else if (src === 'addNote' && this.data['addNote'])
      return this.data['addNote'].messages;

    else
      return "Loading. . ."

  }

  public setTimedLoader(loaderStyle?, loaderSource?, seconds?) {
    var ms = seconds * 1000;
    this.setLoader(loaderStyle, loaderSource)

    setTimeout(() => {
      this.stopLoader();
    }, ms);
  }

  public setTimedLoaderWithSeconds(msg, seconds?) {
    var ms = seconds * 1000;
    this.startLoaderWithMessage(msg)

    setTimeout(() => {
      this.stopLoader();
      localStorage.clear();
    }, ms);
  }

  public get $loaderStatus(): boolean {
    return this.loaderStatus;
  }

  public set $loaderStatus(value: boolean) {
    this.loaderStatus = value;
  }

  public get $loaderStyle(): number {
    return this.loaderStyle;
  }

  public set $loaderStyle(value: number) {
    this.loaderStyle = value;
  }



}
